import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'

import { takeUntil } from 'rxjs/operators'

import { BehaviorSubject } from 'rxjs'
import { ResponseModel } from '../domain/authentication.model'
import { ShortBeatmakerInfo } from '../types/short-beatmaker-info.type'
import { Nullable } from '../types/utils.type'
import { CoreEnvironmentService } from './core-environment.service'
import { DestroyService } from './destroy.service'

@Injectable({
  providedIn: 'root'
})
export class ShortBeatmakerInfoService {
  private readonly coreEnvironmentService = inject(CoreEnvironmentService)
  private readonly destroy$ = inject(DestroyService)
  private readonly http = inject(HttpClient)

  shortBeatmakerInfo$ = new BehaviorSubject<ResponseModel<Nullable<ShortBeatmakerInfo>>>(null)

  private readonly baseUrl = this.coreEnvironmentService.getBeatmakerApiBaseUrl()
  private readonly httpOptions = { withCredentials: true }

  getShortBeatmakerInfo(beatmakerId: number) {
    const url = `${this.baseUrl}/api/beatmakers/${beatmakerId}`

    this.http
      .get<ResponseModel<Nullable<ShortBeatmakerInfo>>>(url, this.httpOptions)
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.shortBeatmakerInfo$.next(result)
      })
  }
}
